import ModeratorPage from './ModeratorPage';

export default ModeratorPage;

